export default "__VITE_ASSET__DBR7vQ6x__"